var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-7 9 48 48",
    enableBackground: "new -7 9 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "guide",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_8",
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", {
    id: "guides"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -7,
    y: 9,
    fill: "#CEE4EA",
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("rect", {
    x: -5,
    y: 11,
    fill: "#E9F2F4",
    width: 44,
    height: 44
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3,
    y: 13,
    fill: "#FFFFFF",
    width: 40,
    height: 40
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "pdf"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_16_"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_19_",
    fill: "#949494",
    points: "28.574,13.103 28.57,13.103 36.519,21.39 36.519,52.897 6.828,52.897 6.828,53  36.622,53 36.622,21.493 28.574,13.103  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_20_",
    fill: "#F1F1F1",
    points: "28.471,13 6.725,13 6.725,52.897 36.519,52.897 36.519,21.39 28.471,13  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_39_",
    fill: "#808080",
    points: "6.506,15.137 -2.622,15.137 -2.622,24.89 6.506,24.89 26.09,24.89 26.09,15.137  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_30_",
    x: -2.436,
    y: 14.969,
    fill: "#DC1D00",
    width: 28.681,
    height: 9.76
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_35_",
    fill: "#4D4D4D",
    d: "M6.802,19.897c-0.042,0-0.084-0.001-0.127-0.002v-2.112h0.276 c0.316,0,0.515,0.101,0.656,0.259c0.176,0.199,0.261,0.549,0.261,0.797c0,0.352,0,0.669-0.317,0.895 C7.381,19.855,7.107,19.897,6.802,19.897 M7.073,16.62c-0.014,0-0.029,0-0.043,0c-0.145,0.003-0.243,0.005-0.296,0.005H5.206 v6.864h1.469v-2.324l0.325,0.018c0.342,0,0.647-0.076,0.924-0.167c0.276-0.091,0.507-0.243,0.705-0.416 c0.197-0.173,0.379-0.396,0.479-0.648c0.15-0.38,0.19-0.916,0.15-1.297c-0.039-0.368-0.054-0.677-0.163-0.919 c-0.108-0.243-0.248-0.44-0.419-0.592c-0.171-0.152-0.358-0.264-0.562-0.337c-0.204-0.073-0.399-0.123-0.587-0.15 C7.359,16.632,7.207,16.62,7.073,16.62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_38_",
    fill: "#4D4D4D",
    d: "M11.786,22.224c-0.046,0-0.092-0.001-0.141-0.003v-4.376c0.006,0,0.012,0,0.019,0 c0.299,0,0.665,0.002,0.855,0.153c0.194,0.155,0.348,0.346,0.463,0.573c0.115,0.227,0.191,0.487,0.202,0.751 c0.013,0.314,0.002,0.566,0.002,0.785c0,0.213-0.001,0.474-0.047,0.732c-0.046,0.258-0.127,0.498-0.242,0.719 c-0.115,0.222-0.325,0.372-0.519,0.514C12.217,22.193,12.02,22.224,11.786,22.224 M12.047,16.601 c-0.159,0-0.313,0.012-0.421,0.016c-0.184,0.006-0.296,0.009-0.335,0.009h-1.114v6.864h1.311c0.578,0,1.068-0.083,1.469-0.25 c0.401-0.167,0.725-0.401,0.971-0.701c0.247-0.3,0.424-0.657,0.532-1.07c0.108-0.413,0.163-0.865,0.163-1.356 c0-0.637,0.002-1.124-0.125-1.61c-0.113-0.434-0.345-0.79-0.578-1.048c-0.233-0.258-0.488-0.449-0.764-0.573 c-0.276-0.124-0.537-0.209-0.784-0.255C12.271,16.606,12.158,16.601,12.047,16.601"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_64_",
    fill: "#4D4D4D",
    points: "19.042,16.625 15.57,16.625 15.57,23.489 17.039,23.489 17.039,20.763  18.894,20.763 18.894,19.488 17.039,19.488 17.039,17.9 19.042,17.9 19.042,16.625  "
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28_",
    fill: "#DC1D00",
    d: "M31.149,39.992c-0.014-0.137-0.137-1.725-2.957-1.657c-2.82,0.068-3.505,0.246-3.505,0.246 s-2.108-2.136-2.875-3.792c0,0,0.931-2.724,0.89-4.436c-0.041-1.711-0.452-2.697-1.766-2.683 c-1.314,0.014-1.506,1.164-1.333,2.876c0.155,1.536,0.95,3.34,0.95,3.34s-0.607,1.889-1.41,3.769 c-0.803,1.88-1.351,2.866-1.351,2.866s-2.715,0.908-3.893,2.003c-1.177,1.095-1.656,1.937-1.036,2.779 c0.534,0.726,2.405,0.89,4.075-1.301c1.67-2.19,2.423-3.559,2.423-3.559s2.549-0.698,3.342-0.89 c0.793-0.192,1.751-0.342,1.751-0.342s2.327,2.341,4.573,2.259C31.272,41.388,31.162,40.129,31.149,39.992z M13.447,44.934 c-1.396-0.835,2.93-3.409,3.71-3.491C17.157,41.443,14.909,45.808,13.447,44.934z M20.087,29.916c0-1.355,0.438-1.725,0.78-1.725 s0.726,0.164,0.739,1.342c0.014,1.177-0.739,3.477-0.739,3.477C20.607,32.736,20.087,31.271,20.087,29.916z M21.89,39.198 c-1.401,0.342-2.104,0.698-2.104,0.698s0,0,0.575-1.287c0.575-1.287,1.164-3.039,1.164-3.039c0.794,1.479,2.368,3.217,2.368,3.217 S23.29,38.856,21.89,39.198z M25.257,39.079c0,0,4.554-0.826,4.554,0.73C29.812,41.365,26.991,40.731,25.257,39.079z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_44_",
    fill: "#949494",
    points: "28.362,13.11 28.362,21.5 36.41,21.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_21_",
    fill: "#F1F1F1",
    points: "28.471,13 28.471,21.39 36.519,21.39  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_23_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_43_",
    fill: "#FFFEFE",
    d: "M6.693,19.787c-0.042,0-0.084-0.001-0.127-0.002v-2.112h0.276 c0.316,0,0.515,0.101,0.656,0.259c0.176,0.199,0.261,0.549,0.261,0.797c0,0.352,0,0.669-0.317,0.895 C7.271,19.746,6.998,19.787,6.693,19.787 M6.963,16.511c-0.014,0-0.029,0-0.043,0c-0.145,0.003-0.243,0.005-0.296,0.005H5.097 v6.864h1.469v-2.324l0.325,0.018c0.342,0,0.647-0.076,0.924-0.167c0.276-0.091,0.507-0.243,0.705-0.416 c0.197-0.173,0.379-0.396,0.479-0.648c0.15-0.38,0.19-0.916,0.15-1.297c-0.039-0.368-0.054-0.677-0.163-0.919 c-0.108-0.243-0.248-0.44-0.419-0.592c-0.171-0.152-0.358-0.264-0.562-0.337c-0.204-0.073-0.399-0.123-0.587-0.15 C7.249,16.523,7.097,16.511,6.963,16.511"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_32_",
    fill: "#FFFEFE",
    d: "M11.676,22.115c-0.046,0-0.092-0.001-0.141-0.003v-4.376c0.006,0,0.012,0,0.019,0 c0.299,0,0.665,0.002,0.855,0.153c0.194,0.155,0.348,0.346,0.463,0.573c0.115,0.227,0.191,0.487,0.202,0.751 c0.013,0.314,0.002,0.566,0.002,0.785c0,0.213-0.001,0.474-0.047,0.732c-0.046,0.258-0.127,0.498-0.242,0.719 c-0.115,0.222-0.325,0.372-0.519,0.514C12.108,22.083,11.91,22.115,11.676,22.115 M11.937,16.491 c-0.159,0-0.313,0.012-0.421,0.016c-0.184,0.006-0.296,0.009-0.335,0.009h-1.114v6.864h1.311c0.578,0,1.068-0.083,1.469-0.25 c0.401-0.167,0.725-0.401,0.971-0.701c0.247-0.3,0.424-0.657,0.532-1.07c0.108-0.413,0.163-0.865,0.163-1.356 c0-0.637,0.002-1.124-0.125-1.61c-0.113-0.434-0.345-0.79-0.578-1.048c-0.233-0.258-0.488-0.449-0.764-0.573 c-0.276-0.124-0.537-0.209-0.784-0.255C12.161,16.497,12.048,16.491,11.937,16.491"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_24_",
    fill: "#FFFEFE",
    points: "18.932,16.516 15.461,16.516 15.461,23.379 16.93,23.379 16.93,20.653  18.785,20.653 18.785,19.379 16.93,19.379 16.93,17.79 18.932,17.79 18.932,16.516  "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "download-fill",
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    display: "inline",
    d: "M30.484,29.397C29.237,23.091,23.673,18.333,17,18.333c-5.298,0-9.891,3.007-12.192,7.397 C-0.701,26.327-5,30.993-5,36.667c0,6.077,4.922,11,11,11h23.833c5.06,0,9.167-4.107,9.167-9.167 C39,33.66,35.232,29.737,30.484,29.397z M26.167,34.833L17,44l-9.167-9.167h5.5V27.5h7.333v7.333H26.167z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "copy-fill",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.063,46.125c-4.1,0-7.438-3.337-7.438-7.438V20.75H2.563c-2.655,0-4.813,2.158-4.813,4.812v23.625 C-2.25,51.842-0.092,54,2.563,54h21.875c2.655,0,4.813-2.158,4.813-4.813v-3.063H13.063z M13.063,46.125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.25,16.813c0-2.658-2.154-4.813-4.813-4.813H13.063c-2.658,0-4.813,2.154-4.813,4.813v21.875 c0,2.658,2.154,4.813,4.813,4.813h18.375c2.658,0,4.813-2.154,4.813-4.813V16.813z M36.25,16.813"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "excel",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -3,
    y: 13.729,
    width: 40,
    height: 38.542
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#4CAF50",
    d: "M20.02,14.017c-0.198-0.161-0.458-0.222-0.707-0.167l-21.667,5 c-0.381,0.088-0.65,0.429-0.647,0.82v28.333c0,0.411,0.3,0.761,0.707,0.824l21.667,3.333c0.455,0.07,0.88-0.242,0.95-0.697 c0.007-0.042,0.01-0.084,0.01-0.126V14.67C20.334,14.416,20.219,14.176,20.02,14.017L20.02,14.017z M20.02,14.017"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4CAF50",
    d: "M36.167,48.837H19.5c-0.46,0-0.833-0.373-0.833-0.833S19.04,47.17,19.5,47.17h15.833V18.837H19.5 c-0.46,0-0.833-0.373-0.833-0.833c0-0.46,0.373-0.833,0.833-0.833h16.667c0.46,0,0.833,0.373,0.833,0.833v30 C37,48.464,36.627,48.837,36.167,48.837L36.167,48.837z M36.167,48.837"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M12.833,40.503c-0.287,0-0.554-0.148-0.707-0.391L3.793,26.778c-0.256-0.382-0.154-0.9,0.229-1.156 c0.382-0.256,0.9-0.154,1.156,0.229c0.01,0.015,0.02,0.031,0.029,0.046L13.54,39.23c0.243,0.391,0.123,0.904-0.268,1.148 C13.141,40.46,12.988,40.503,12.833,40.503L12.833,40.503z M12.833,40.503"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M4.5,40.503c-0.46-0.001-0.832-0.375-0.832-0.835c0-0.156,0.044-0.308,0.126-0.44l8.333-13.333 c0.231-0.398,0.741-0.534,1.139-0.303c0.398,0.231,0.534,0.741,0.303,1.139c-0.009,0.016-0.018,0.031-0.028,0.046L5.208,40.11 C5.056,40.355,4.788,40.504,4.5,40.503L4.5,40.503z M4.5,40.503"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4CAF50",
    d: "M26.167,48.837c-0.46,0-0.833-0.373-0.833-0.833v-30c0-0.46,0.373-0.833,0.833-0.833 c0.46,0,0.833,0.373,0.833,0.833v30C27,48.464,26.627,48.837,26.167,48.837L26.167,48.837z M26.167,48.837"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4CAF50",
    d: "M36.167,43.837H19.5c-0.46,0-0.833-0.373-0.833-0.833S19.04,42.17,19.5,42.17h16.667 c0.46,0,0.833,0.373,0.833,0.833C37,43.464,36.627,43.837,36.167,43.837L36.167,43.837z M36.167,43.837"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4CAF50",
    d: "M36.167,38.837H19.5c-0.46,0-0.833-0.373-0.833-0.833S19.04,37.17,19.5,37.17h16.667 c0.46,0,0.833,0.373,0.833,0.833C37,38.464,36.627,38.837,36.167,38.837L36.167,38.837z M36.167,38.837"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4CAF50",
    d: "M36.167,33.837H19.5c-0.46,0-0.833-0.373-0.833-0.833S19.04,32.17,19.5,32.17h16.667 c0.46,0,0.833,0.373,0.833,0.833C37,33.464,36.627,33.837,36.167,33.837L36.167,33.837z M36.167,33.837"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4CAF50",
    d: "M36.167,28.837H19.5c-0.46,0-0.833-0.373-0.833-0.833c0-0.46,0.373-0.833,0.833-0.833h16.667 c0.46,0,0.833,0.373,0.833,0.833C37,28.463,36.627,28.837,36.167,28.837L36.167,28.837z M36.167,28.837"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4CAF50",
    d: "M36.167,23.837H19.5c-0.46,0-0.833-0.373-0.833-0.833c0-0.46,0.373-0.833,0.833-0.833h16.667 c0.46,0,0.833,0.373,0.833,0.833C37,23.464,36.627,23.837,36.167,23.837L36.167,23.837z M36.167,23.837"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "jpg",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E2E5E7",
    d: "M7,13c-1.375,0-2.5,1.125-2.5,2.5v35C4.5,51.875,5.625,53,7,53h25c1.375,0,2.5-1.125,2.5-2.5V23l-10-10H7z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B0B7BD",
    d: "M27,23h7.5l-10-10v7.5C24.5,21.875,25.625,23,27,23z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CAD1D8",
    points: "34.5,30.5 27,23 34.5,23  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#50BEE8",
    d: "M29.5,45.5c0,0.688-0.563,1.25-1.25,1.25H0.75c-0.688,0-1.25-0.563-1.25-1.25V33 c0-0.688,0.563-1.25,1.25-1.25h27.5c0.688,0,1.25,0.563,1.25,1.25V45.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M8.091,36.684c0-0.84,1.32-0.84,1.32,0v3.947c0,1.57-0.75,2.52-2.479,2.52 c-0.85,0-1.559-0.231-2.179-1.03c-0.51-0.61,0.45-1.489,0.97-0.85c0.42,0.52,0.87,0.64,1.309,0.62 c0.559-0.02,1.05-0.271,1.06-1.26v-3.948H8.091z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M11.167,36.684c0-0.33,0.26-0.69,0.68-0.69h2.309c1.3,0,2.47,0.87,2.47,2.537c0,1.58-1.17,2.46-2.47,2.46 h-1.669v1.32c0,0.44-0.28,0.689-0.64,0.689c-0.33,0-0.68-0.249-0.68-0.689L11.167,36.684L11.167,36.684z M12.488,37.253v2.49 h1.669c0.67,0,1.2-0.591,1.2-1.211c0-0.699-0.53-1.279-1.2-1.279H12.488z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M23.764,42.231c-0.71,0.59-1.58,0.84-2.459,0.84c-2.1,0-3.589-1.199-3.589-3.579 c0-2.018,1.57-3.586,3.677-3.586c0.79,0,1.659,0.269,2.279,0.879c0.609,0.599-0.27,1.489-0.869,0.96 c-0.37-0.36-0.89-0.63-1.41-0.63c-1.209,0-2.378,0.969-2.378,2.378c0,1.48,0.979,2.38,2.289,2.38c0.609,0,1.129-0.181,1.499-0.45 v-1.229h-1.499c-0.89,0-0.8-1.22,0-1.22h1.999c0.37,0,0.709,0.28,0.709,0.59v2.129C24.013,41.872,23.934,42.04,23.764,42.231z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M28.25,46.75H4.5V48h23.75c0.688,0,1.25-0.563,1.25-1.25V45.5C29.5,46.188,28.938,46.75,28.25,46.75z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "png",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E2E5E7",
    d: "M7,13c-1.375,0-2.5,1.125-2.5,2.5v35C4.5,51.875,5.625,53,7,53h25c1.375,0,2.5-1.125,2.5-2.5V23l-10-10H7z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B0B7BD",
    d: "M27,23h7.5l-10-10v7.5C24.5,21.875,25.625,23,27,23z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CAD1D8",
    points: "34.5,30.5 27,23 34.5,23  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A066AA",
    d: "M29.5,45.5c0,0.688-0.563,1.25-1.25,1.25H0.75c-0.688,0-1.25-0.563-1.25-1.25V33 c0-0.688,0.563-1.25,1.25-1.25h27.5c0.688,0,1.25,0.563,1.25,1.25V45.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M4.251,36.684c0-0.33,0.259-0.691,0.679-0.691h2.31c1.299,0,2.469,0.87,2.469,2.539 c0,1.58-1.17,2.459-2.469,2.459H5.569v1.32c0,0.441-0.278,0.69-0.639,0.69c-0.33,0-0.679-0.249-0.679-0.69L4.251,36.684z  M5.569,37.253v2.489h1.67c0.669,0,1.199-0.59,1.199-1.21c0-0.7-0.53-1.279-1.199-1.279L5.569,37.253L5.569,37.253z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M10.983,36.784c0-0.361,0.08-0.71,0.6-0.71c0.359,0,0.44,0.09,0.709,0.349l3.307,4.139v-3.877 c0-0.33,0.289-0.691,0.63-0.691c0.36,0,0.709,0.361,0.709,0.691v5.626c0,0.441-0.27,0.609-0.53,0.69 c-0.349,0-0.52-0.08-0.809-0.349l-3.307-4.199v3.859c0,0.441-0.27,0.69-0.63,0.69s-0.68-0.249-0.68-0.69v-5.528H10.983z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M24.456,42.231c-0.71,0.589-1.58,0.84-2.459,0.84c-2.1,0-3.589-1.2-3.589-3.579 c0-2.019,1.57-3.587,3.677-3.587c0.79,0,1.659,0.27,2.279,0.88c0.61,0.599-0.27,1.489-0.869,0.96 c-0.37-0.361-0.89-0.63-1.41-0.63c-1.209,0-2.378,0.969-2.378,2.378c0,1.48,0.979,2.379,2.289,2.379 c0.609,0,1.129-0.18,1.499-0.45v-1.228h-1.499c-0.89,0-0.8-1.221,0-1.221h1.999c0.37,0,0.709,0.281,0.709,0.591v2.129 C24.705,41.871,24.626,42.04,24.456,42.231z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M28.25,46.75H4.5V48h23.75c0.688,0,1.25-0.563,1.25-1.25V45.5C29.5,46.188,28.938,46.75,28.25,46.75z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "ppt",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E2E5E7",
    d: "M7,13c-1.375,0-2.5,1.125-2.5,2.5v35C4.5,51.875,5.625,53,7,53h25c1.375,0,2.5-1.125,2.5-2.5V23l-10-10H7z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F15642",
    d: "M29.5,45.5c0,0.688-0.563,1.25-1.25,1.25H0.75c-0.688,0-1.25-0.563-1.25-1.25V33 c0-0.688,0.563-1.25,1.25-1.25h27.5c0.688,0,1.25,0.563,1.25,1.25V45.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M5.239,36.684c0-0.33,0.26-0.69,0.679-0.69h2.309c1.3,0,2.47,0.87,2.47,2.537c0,1.58-1.17,2.46-2.47,2.46 H6.557v1.32c0,0.44-0.279,0.689-0.639,0.689c-0.33,0-0.679-0.249-0.679-0.689v-5.627H5.239z M6.557,37.253v2.49h1.669 c0.67,0,1.2-0.591,1.2-1.211c0-0.699-0.53-1.279-1.2-1.279H6.557z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M11.97,36.684c0-0.33,0.26-0.69,0.68-0.69h2.309c1.3,0,2.47,0.87,2.47,2.537c0,1.58-1.17,2.46-2.47,2.46 H13.29v1.32c0,0.44-0.28,0.689-0.64,0.689c-0.33,0-0.68-0.249-0.68-0.689V36.684z M13.289,37.253v2.49h1.669 c0.67,0,1.2-0.591,1.2-1.211c0-0.699-0.53-1.279-1.2-1.279H13.289z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M20.569,37.334h-1.747c-0.87,0-0.87-1.279,0-1.279h4.726c0.89,0,0.89,1.279,0,1.279h-1.659v5.048 c0,0.869-1.32,0.89-1.32,0V37.334z"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "rar",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#97D85D",
    d: "M34.843,13H-0.843c-0.65,0-1.176,0.527-1.176,1.177v37.647c0,0.65,0.527,1.177,1.176,1.177h35.686 c0.65,0,1.176-0.527,1.176-1.177V14.177C36.019,13.527,35.493,13,34.843,13L34.843,13z M34.843,13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#71B22D",
    d: "M34.845,13.788H17.372V53h17.473c0.649,0,1.174-0.516,1.174-1.154V14.942 C36.019,14.304,35.494,13.788,34.845,13.788L34.845,13.788z M34.845,13.788"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC4F4F",
    d: "M34.841,25.646H-0.768c-0.651,0-1.179,0.528-1.179,1.179V40.43H36.02V26.825 C36.019,26.174,35.492,25.646,34.841,25.646L34.841,25.646z M34.841,25.646"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A60E5",
    d: "M34.841,13H-0.768c-0.651,0-1.179,0.48-1.179,1.072v12.369H36.02V14.072C36.019,13.48,35.492,13,34.841,13 L34.841,13z M34.841,13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD561",
    d: "M6.767,42.754H2.759c-0.651,0-1.179,0.528-1.179,1.179v5.72c0,0.651,0.528,1.179,1.179,1.179h4.008 c0.651,0,1.179-0.528,1.179-1.179v-5.72C7.946,43.282,7.418,42.754,6.767,42.754L6.767,42.754z M6.767,42.754"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD561",
    d: "M6.767,29.396H2.759c-0.651,0-1.179,0.528-1.179,1.179v5.72c0,0.651,0.528,1.179,1.179,1.179h4.008 c0.651,0,1.179-0.528,1.179-1.179v-5.72C7.946,29.924,7.418,29.396,6.767,29.396L6.767,29.396z M6.767,29.396"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD561",
    d: "M6.767,15.646H2.759c-0.651,0-1.179,0.528-1.179,1.179v5.72c0,0.651,0.528,1.179,1.179,1.179h4.008 c0.651,0,1.179-0.528,1.179-1.179v-5.72C7.946,16.173,7.418,15.646,6.767,15.646L6.767,15.646z M6.767,15.646"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A4BD8",
    d: "M34.841,13H17.372v13.441h18.647V14.072C36.019,13.48,35.492,13,34.841,13L34.841,13z M34.841,13"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.372,
    y: 25.646,
    fill: "#E53535",
    width: 18.647,
    height: 14.784
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBE69",
    d: "M21.812,53c0.651,0,1.179-0.527,1.179-1.177V14.177c0-0.65-0.528-1.177-1.179-1.177h-10.06v40H21.812z  M21.812,53"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.753,
    y: 28.031,
    fill: "#FF9852",
    width: 11.238,
    height: 9.902
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF8A33",
    d: "M17.372,25.987c-0.651,0-1.179,0.528-1.179,1.179v3.615c0,0.651,0.528,1.179,1.179,1.179 c0.651,0,1.179-0.528,1.179-1.179v-3.615C18.551,26.515,18.023,25.987,17.372,25.987L17.372,25.987z M17.372,25.987"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.372,
    y: 13,
    fill: "#F4B04D",
    width: 5.619,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.372,
    y: 28.031,
    fill: "#FF8A33",
    width: 5.619,
    height: 9.902
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F96E10",
    d: "M17.372,25.987v5.973c0.651,0,1.179-0.528,1.179-1.179v-3.615C18.551,26.515,18.023,25.987,17.372,25.987 L17.372,25.987z M17.372,25.987"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "vision",
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    display: "inline",
    d: "M36.78,32.318c-0.357-0.499-8.869-12.209-19.702-12.209c-10.834,0-19.502,11.709-19.859,12.209 c-0.293,0.408-0.293,0.957,0,1.364c0.357,0.499,9.025,12.209,19.859,12.209c10.833,0,19.345-11.709,19.702-12.209 C37.073,33.275,37.073,32.726,36.78,32.318z M17.079,41.203c-4.523,0-8.359-3.681-8.359-8.203s3.837-8.203,8.359-8.203 s8.203,3.681,8.203,8.203S21.601,41.203,17.079,41.203z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "word",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: -3,
    y: 13.729,
    width: 40,
    height: 38.542
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "#1565C0",
    d: "M20.02,14.017c-0.198-0.161-0.458-0.222-0.707-0.167l-21.667,5 c-0.381,0.088-0.65,0.429-0.647,0.82v28.333c0,0.411,0.3,0.761,0.707,0.824l21.667,3.333c0.455,0.07,0.88-0.242,0.95-0.697 c0.007-0.042,0.01-0.084,0.01-0.126V14.67C20.334,14.416,20.219,14.176,20.02,14.017L20.02,14.017z M20.02,14.017"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1565C0",
    d: "M36.167,48.837H19.5c-0.46,0-0.833-0.373-0.833-0.833S19.04,47.17,19.5,47.17h15.833V18.837H19.5 c-0.46,0-0.833-0.373-0.833-0.833c0-0.46,0.373-0.833,0.833-0.833h16.667c0.46,0,0.833,0.373,0.833,0.833v30 C37,48.464,36.627,48.837,36.167,48.837L36.167,48.837z M36.167,48.837"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M11.167,40.503c-0.371,0-0.697-0.246-0.8-0.603l-2.533-8.864L5.3,39.9c-0.183,0.442-0.69,0.652-1.132,0.47 c-0.213-0.088-0.382-0.257-0.469-0.47L0.365,28.234c-0.14-0.439,0.103-0.907,0.542-1.047c0.439-0.139,0.907,0.103,1.047,0.542 c0.005,0.015,0.009,0.031,0.013,0.047L4.5,36.637l2.533-8.864c0.183-0.442,0.69-0.652,1.132-0.47 c0.213,0.088,0.382,0.257,0.469,0.47l2.532,8.864l2.533-8.862c0.12-0.438,0.573-0.697,1.012-0.577 c0.006,0.002,0.012,0.004,0.018,0.005c0.442,0.127,0.698,0.588,0.572,1.03L11.968,39.9C11.866,40.257,11.539,40.504,11.167,40.503 L11.167,40.503z M11.167,40.503"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1565C0",
    d: "M32.833,23.837H19.5c-0.46,0-0.833-0.373-0.833-0.833c0-0.46,0.373-0.833,0.833-0.833h13.333 c0.46,0,0.833,0.373,0.833,0.833C33.667,23.464,33.294,23.837,32.833,23.837L32.833,23.837z M32.833,23.837"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1565C0",
    d: "M32.833,28.837H19.5c-0.46,0-0.833-0.373-0.833-0.833c0-0.46,0.373-0.833,0.833-0.833h13.333 c0.46,0,0.833,0.373,0.833,0.833C33.667,28.463,33.294,28.837,32.833,28.837L32.833,28.837z M32.833,28.837"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1565C0",
    d: "M32.833,33.837H19.5c-0.46,0-0.833-0.373-0.833-0.833S19.04,32.17,19.5,32.17h13.333 c0.46,0,0.833,0.373,0.833,0.833C33.667,33.464,33.294,33.837,32.833,33.837L32.833,33.837z M32.833,33.837"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1565C0",
    d: "M32.833,38.837H19.5c-0.46,0-0.833-0.373-0.833-0.833S19.04,37.17,19.5,37.17h13.333 c0.46,0,0.833,0.373,0.833,0.833C33.667,38.464,33.294,38.837,32.833,38.837L32.833,38.837z M32.833,38.837"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1565C0",
    d: "M32.833,43.837H19.5c-0.46,0-0.833-0.373-0.833-0.833S19.04,42.17,19.5,42.17h13.333 c0.46,0,0.833,0.373,0.833,0.833C33.667,43.464,33.294,43.837,32.833,43.837L32.833,43.837z M32.833,43.837"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "zip",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0C419",
    d: "M37,26.103v20c0,2.285-1.853,4.138-4.138,4.138H1.138C-1.147,50.241-3,48.389-3,46.103V15.759 C-3,14.235-1.765,13-0.241,13h15.172c1.524,0,2.759,1.235,2.759,2.759v1.379h12.414c1.523,0,2.759,1.235,2.759,2.759v2.069 C35.146,21.969,36.997,23.819,37,26.103L37,26.103z M37,26.103"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F29C1F",
    d: "M32.862,19.897v2.069H-3v-6.207C-3,14.235-1.765,13-0.241,13h15.172c1.524,0,2.759,1.235,2.759,2.759 v1.379h12.414C31.627,17.138,32.862,18.373,32.862,19.897L32.862,19.897z M32.862,19.897"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E57E25",
    d: "M9.414,21.966H6.655c-0.381,0-0.69-0.309-0.69-0.69c0-0.381,0.308-0.69,0.69-0.69h2.758 c0.381,0,0.69,0.309,0.69,0.69C10.103,21.657,9.795,21.966,9.414,21.966L9.414,21.966z M9.414,21.966"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#547580",
    d: "M17,41.276c-0.381,0-0.69-0.309-0.69-0.69V21.966c0-0.381,0.309-0.69,0.69-0.69 c0.381,0,0.69,0.309,0.69,0.69v18.621C17.69,40.967,17.381,41.276,17,41.276L17,41.276z M17,41.276"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F8C8D",
    d: "M14.931,25.414h-0.69c-0.381,0-0.689-0.309-0.689-0.69c0-0.381,0.308-0.69,0.689-0.69h0.69 c0.381,0,0.69,0.309,0.69,0.69C15.621,25.105,15.312,25.414,14.931,25.414L14.931,25.414z M14.931,25.414"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F8C8D",
    d: "M14.931,28.172h-0.69c-0.381,0-0.689-0.309-0.689-0.69s0.308-0.69,0.689-0.69h0.69 c0.381,0,0.69,0.309,0.69,0.69S15.312,28.172,14.931,28.172L14.931,28.172z M14.931,28.172"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F8C8D",
    d: "M14.931,30.931h-0.69c-0.381,0-0.689-0.309-0.689-0.69c0-0.381,0.308-0.689,0.689-0.689h0.69 c0.381,0,0.69,0.308,0.69,0.689C15.621,30.622,15.312,30.931,14.931,30.931L14.931,30.931z M14.931,30.931"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F8C8D",
    d: "M14.931,33.69h-0.69c-0.381,0-0.689-0.309-0.689-0.69c0-0.381,0.308-0.69,0.689-0.69h0.69 c0.381,0,0.69,0.309,0.69,0.69C15.621,33.381,15.312,33.69,14.931,33.69L14.931,33.69z M14.931,33.69"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F8C8D",
    d: "M14.931,36.448h-0.69c-0.381,0-0.689-0.308-0.689-0.689c0-0.381,0.308-0.69,0.689-0.69h0.69 c0.381,0,0.69,0.309,0.69,0.69C15.621,36.14,15.312,36.448,14.931,36.448L14.931,36.448z M14.931,36.448"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F8C8D",
    d: "M14.931,39.207h-0.69c-0.381,0-0.689-0.309-0.689-0.69s0.308-0.69,0.689-0.69h0.69 c0.381,0,0.69,0.309,0.69,0.69S15.312,39.207,14.931,39.207L14.931,39.207z M14.931,39.207"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F8C8D",
    d: "M19.759,26.793h-0.69c-0.381,0-0.69-0.309-0.69-0.69c0-0.381,0.309-0.69,0.69-0.69h0.69 c0.381,0,0.689,0.309,0.689,0.69C20.448,26.484,20.14,26.793,19.759,26.793L19.759,26.793z M19.759,26.793"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F8C8D",
    d: "M19.759,29.552h-0.69c-0.381,0-0.69-0.309-0.69-0.69c0-0.381,0.309-0.69,0.69-0.69h0.69 c0.381,0,0.689,0.309,0.689,0.69C20.448,29.243,20.14,29.552,19.759,29.552L19.759,29.552z M19.759,29.552"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F8C8D",
    d: "M19.759,32.31h-0.69c-0.381,0-0.69-0.309-0.69-0.69c0-0.381,0.309-0.69,0.69-0.69h0.69 c0.381,0,0.689,0.309,0.689,0.69C20.448,32.001,20.14,32.31,19.759,32.31L19.759,32.31z M19.759,32.31"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F8C8D",
    d: "M19.759,35.069h-0.69c-0.381,0-0.69-0.309-0.69-0.69c0-0.381,0.309-0.69,0.69-0.69h0.69 c0.381,0,0.689,0.309,0.689,0.69C20.448,34.76,20.14,35.069,19.759,35.069L19.759,35.069z M19.759,35.069"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F8C8D",
    d: "M19.759,37.827h-0.69c-0.381,0-0.69-0.309-0.69-0.69c0-0.381,0.309-0.69,0.69-0.69h0.69 c0.381,0,0.689,0.309,0.689,0.69C20.448,37.519,20.14,37.827,19.759,37.827L19.759,37.827z M19.759,37.827"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7F8C8D",
    d: "M19.069,44.724l2.652,6.366c0.177,0.426,0.13,0.912-0.125,1.296C21.34,52.769,20.909,53,20.448,53h-6.896 c-0.461,0-0.892-0.231-1.148-0.614c-0.256-0.384-0.303-0.87-0.125-1.296l2.652-6.366H19.069z M19.069,44.724"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#547580",
    d: "M17.69,50.931H16.31c-0.381,0-0.69-0.309-0.69-0.69c0-0.381,0.309-0.689,0.69-0.689h1.379 c0.381,0,0.69,0.308,0.69,0.689C18.379,50.622,18.071,50.931,17.69,50.931L17.69,50.931z M17.69,50.931"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E57E25",
    d: "M32.862,20.586v1.379h-20c-0.381,0-0.69-0.309-0.69-0.69c0-0.381,0.309-0.69,0.69-0.69H32.862z  M32.862,20.586"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#95A5A5",
    d: "M14.931,40.586h4.138c0.382,0,0.69,0.308,0.69,0.69v2.758c0,0.382-0.308,0.69-0.69,0.69h-4.138 c-0.382,0-0.69-0.308-0.69-0.69v-2.758C14.241,40.894,14.549,40.586,14.931,40.586L14.931,40.586z M14.931,40.586"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.8400a28b80e230592a4d7d631305fc0e.svg";
export { ForwardRef as ReactComponent };